module.exports = __webpack_public_path__ + "static/media/starWars.435016c1.png";